import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=c8ca98fc&scoped=true&lang=pug"
import script from "./Rooms.vue?vue&type=script&lang=ts"
export * from "./Rooms.vue?vue&type=script&lang=ts"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=c8ca98fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ca98fc",
  null
  
)

export default component.exports